import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["productModel", "category"]

  static values = {
    productModelCategoryPromptMap: Object,
  }

  connect() {
    this.defaultCategoryPrompt = this.categoryBlankOption?.label || this.categoryBlankOption?.text || ""
    this.setCategoryFromProductModel()
  }

  updateCategory() {
    this.setCategoryFromProductModel()
  }

  setCategoryFromProductModel() {
    const productModelId = this.productModelTarget.value
    const inheritedCategoryPrompt = this.productModelCategoryPromptMapValue[productModelId] || ""

    if (this.categoryBlankOption) {
      const prompt = inheritedCategoryPrompt || this.defaultCategoryPrompt
      this.categoryBlankOption.text = prompt
      this.categoryBlankOption.label = prompt
      this.categoryBlankOption.setAttribute("label", prompt)
    }
  }

  get categoryBlankOption() {
    return this.categoryTarget.querySelector('option[value=""]')
  }
}
